import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import Breadcrumbs from 'components/Breadcrumbs';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import styles from 'pages/company/code-of-ethics/CodeOfEthics.module.scss';

const cn = classNames.bind(styles);

type CodeOfEthicsProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

const SectionHeader = dynamic(() => import('sections/Company/CodeOfEthics/components/SectionHeader/'));
const SectionFeatures = dynamic(() => import('sections/Company/CodeOfEthics/components/SectionFeatures/'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Company/CodeOfEthics/components/SectionForm/'));

export default function CodeOfEthics({ pageTitle, formUrl, leadSubtype }: CodeOfEthicsProps) {
  return (
    <section className={cn('code-of-ethics')}>
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Code of Ethics', href: '' as Route}]} />
      </div>
      <SectionHeader />
      <SectionFeatures />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
    </section>
  );
}

export const getStaticProps = async () => {
  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.CodeOfEthics.pageTitle,
  //   formUrl: LeadFormParameters.CodeOfEthics.formUrl,
  //   leadSubtype: LeadFormParameters.CodeOfEthics.leadSubtype,
  // };

  return {
    props: {
      title: 'DF Alliance Code of Ethics | DF Alliance',
      description:
        'Review DF Alliance\'s Code of Ethics to understand the principles and standards guiding our global logistics network and commitment to integrity and professionalism.',
      path: '/company/code-of-ethics',
    },
  };
};

CodeOfEthics.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
